export const featuredProducts = [
  {
    id: 1,
    name: "都會氣質修身洋裝",
    tagline: "修飾曲線，氣質出眾",
    originalPrice: 5800,
    salePrice: 2980,
    image: "https://readdy.ai/api/search-image?query=elegant%20taiwanese%20designer%20women%20dress%20slim%20fit%20midi%20dress%20worn%20by%20mature%20woman%20minimalist%20cream%20beige%20background%20professional%20photography%20high%20quality%20fabric%20graceful%20silhouette&width=400&height=560&seq=p001&orientation=portrait",
    badge: "新品",
    category: "洋裝系列",
  },
  {
    id: 2,
    name: "優雅職場西裝外套",
    tagline: "俐落有型，一件多穿",
    originalPrice: 6500,
    salePrice: 3480,
    image: "https://readdy.ai/api/search-image?query=elegant%20women%20blazer%20jacket%20tailored%20fit%20worn%20by%20mature%20professional%20woman%20warm%20rose%20beige%20minimalist%20background%20taiwanese%20designer%20brand%20high%20quality&width=400&height=560&seq=p002&orientation=portrait",
    badge: "熱銷",
    category: "外套系列",
  },
  {
    id: 3,
    name: "雪紡寬管顯瘦長褲",
    tagline: "顯瘦顯高，輕盈飄逸",
    originalPrice: 4200,
    salePrice: 2180,
    image: "https://readdy.ai/api/search-image?query=elegant%20women%20wide%20leg%20chiffon%20pants%20flowy%20silhouette%20worn%20by%20mature%20woman%20cream%20white%20background%20taiwanese%20designer%20fashion%20graceful%20high%20quality%20fabric&width=400&height=560&seq=p003&orientation=portrait",
    badge: "Outlet",
    category: "褲裝系列",
  },
  {
    id: 4,
    name: "氣質圓領針織上衣",
    tagline: "柔軟舒適，百搭經典",
    originalPrice: 3200,
    salePrice: 1580,
    image: "https://readdy.ai/api/search-image?query=elegant%20women%20knit%20top%20round%20neck%20soft%20fabric%20worn%20by%20mature%20woman%20warm%20beige%20background%20taiwanese%20designer%20classic%20wardrobe%20staple%20minimalist&width=400&height=560&seq=p004&orientation=portrait",
    badge: "特價",
    category: "上衣系列",
  },
  {
    id: 5,
    name: "典雅修身套裝組",
    tagline: "上下搭配，完美比例",
    originalPrice: 8900,
    salePrice: 4580,
    image: "https://readdy.ai/api/search-image?query=elegant%20women%20matching%20suit%20set%20jacket%20and%20pants%20mature%20professional%20woman%20dusty%20rose%20gray%20tone%20taiwanese%20designer%20brand%20quality%20fabric%20graceful%20posture&width=400&height=560&seq=p005&orientation=portrait",
    badge: "新品",
    category: "套裝系列",
  },
  {
    id: 6,
    name: "垂墜感印花連身裙",
    tagline: "優雅大方，場合百搭",
    originalPrice: 5200,
    salePrice: 2680,
    image: "https://readdy.ai/api/search-image?query=elegant%20floral%20print%20midi%20dress%20draping%20fabric%20worn%20by%20mature%20woman%20cream%20background%20taiwanese%20designer%20outlet%20feminine%20graceful%20quality%20fashion&width=400&height=560&seq=p006&orientation=portrait",
    badge: "Outlet",
    category: "洋裝系列",
  },
];

export const productCategories = [
  {
    id: "tops",
    name: "上衣系列",
    description: "輕盈質感，百搭必備",
    image: "https://readdy.ai/api/search-image?query=elegant%20women%20blouse%20tops%20collection%20displayed%20on%20rack%20warm%20cream%20background%20taiwanese%20designer%20fashion%20quality%20fabric%20minimalist%20boutique&width=400&height=500&seq=cat001&orientation=portrait",
  },
  {
    id: "dresses",
    name: "洋裝系列",
    description: "修身剪裁，優雅出眾",
    image: "https://readdy.ai/api/search-image?query=elegant%20women%20dress%20collection%20displayed%20boutique%20beige%20background%20taiwanese%20designer%20midi%20dress%20mature%20feminine%20quality%20fabric%20graceful&width=400&height=500&seq=cat002&orientation=portrait",
  },
  {
    id: "jackets",
    name: "外套系列",
    description: "俐落層次，四季通用",
    image: "https://readdy.ai/api/search-image?query=elegant%20women%20jacket%20coat%20collection%20boutique%20warm%20neutral%20background%20taiwanese%20designer%20professional%20quality%20tailored%20mature%20style&width=400&height=500&seq=cat003&orientation=portrait",
  },
  {
    id: "pants",
    name: "褲裝系列",
    description: "顯高顯瘦，舒適實穿",
    image: "https://readdy.ai/api/search-image?query=elegant%20women%20pants%20trousers%20collection%20boutique%20cream%20background%20taiwanese%20designer%20fashion%20wide%20leg%20mature%20style%20quality&width=400&height=500&seq=cat004&orientation=portrait",
  },
  {
    id: "suits",
    name: "套裝系列",
    description: "整體搭配，完美比例",
    image: "https://readdy.ai/api/search-image?query=elegant%20women%20matching%20suit%20set%20collection%20boutique%20warm%20beige%20background%20taiwanese%20designer%20professional%20mature%20urban%20style%20quality%20fabric&width=400&height=500&seq=cat005&orientation=portrait",
  },
  {
    id: "sale",
    name: "特價專區",
    description: "Outlet 精選，品質如一",
    image: "https://readdy.ai/api/search-image?query=women%20fashion%20outlet%20sale%20boutique%20elegant%20clothing%20collection%20warm%20rose%20gold%20background%20designer%20brand%20quality%20discount%20special%20offer&width=400&height=500&seq=cat006&orientation=portrait",
  },
];
